<template>
  <div>
    <span>{{ importe }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererMoneda',
  computed: {
    importe () {
      const imp = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(this.params.value)
      return imp
    }
  }
}
</script>